<ul class="list-inline rating-list" *ngFor="let star of stars; let i = index" [ngClass]="{ firstSelected: i === 0 }">
  <li (click)="countStar(star)" [ngClass]="{ selected: star <= selectedValue }" (mouseover)="addClass(star)" (mouseout)="removeClass()"><span class="material-icons">star</span></li>
</ul>
